import React from "react";
import { Instagram, Send, Twitter, PawPrint } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/i18n/LanguageSwitcher";

export const LandingFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-border/50 py-10 px-4" style={{ background: "hsl(25 30% 95% / 0.5)" }}>
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-6 mb-6">
          <div className="text-center md:text-left">
            <p className="text-sm font-semibold text-foreground tracking-[1px]">PETERNITY 🐾</p>
            <p className="text-xs italic mt-1 text-muted-foreground/60">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <div className="flex items-center gap-3">
              {[
                { icon: Instagram, label: "Instagram" },
                { icon: Send, label: "Telegram" },
                { icon: Twitter, label: "Twitter" },
              ].map(({ icon: Icon, label }) => (
                <button
                  key={label}
                  aria-label={label}
                  className="w-9 h-9 rounded-full border border-border/50 flex items-center justify-center text-muted-foreground/50 hover:text-primary hover:border-primary/30 transition-colors duration-200"
                >
                  <Icon className="w-4 h-4" />
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-6 flex-wrap justify-center mb-6">
          {[
            { label: t('footer.features_link'), href: "#features" },
            { label: t('footer.how_it_works_link'), href: "#how-it-works" },
            { label: t('footer.faq_link'), href: "#faq" },
          ].map((link, i) => (
            <button
              key={i}
              onClick={() => document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" })}
              className="text-[13px] text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </button>
          ))}
          <a href="/garden" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">
            {t('footer.garden_link')}
          </a>
          <a href="/blog" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">
            {t('footer.blog_link')}
          </a>
        </div>

        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors">{t('footer.terms')}</a>
            <a href="#" className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors">{t('footer.privacy')}</a>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground/50">
            <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
            <PawPrint className="w-3 h-3" />
          </div>
        </div>
      </div>
    </footer>
  );
};
